import React, { useContext, useEffect, useState } from 'react';

import AppContext from '../../context';
import { fetchSummary } from '../../../api';
import SummaryTable from './summary_table.component';
import { Fallback, ErrorBlock } from '../common/common';
import './summary.component.css';

const Summary = React.forwardRef((props, ref) => {
  const context = useContext(AppContext);
  const portfolio_id = props.pf.id;
  const [summary, setSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await fetchSummary(portfolio_id);
        setSummary(response.data.data.summary);
      } catch (error) {
        setError('Something went wrong');
      }
      setIsLoading(false);
    };
    if (!summary || (summary && context.resetPf.resetId == portfolio_id))
      fetchData();
  }, [context.resetPf]);

  return (
    <>
      <div ref={ref} className="pf_summary__cont">
        {isLoading ? (
          <Fallback height="120px" />
        ) : error ? (
          <ErrorBlock />
        ) : (
          <>
            <SummaryTable
              returnsType={props.returnsType || 'abs'}
              current_value={summary.total_market_value}
              pe={summary.pe}
              one_day_change={summary.one_day_change}
              gain_loss={summary.total_gain_or_loss}
              gain_loss_perc={summary.total_gain_or_loss_perc}
              gain_loss_abs_perc={summary.total_gain_or_loss_abs_perc}
              inception_date={summary.inception_date}
              pf={props.pf}
              setContext={props.setContext}
              setShowManagePf={props.setShowManagePf}
              setShowImportMFs={props.setShowImportMFs}
              setShowSyncBrokerMF={props.setShowSyncBrokerMF}
              setCurrentPf={props.setCurrentPf}
              setManagePfFrom={props.setManagePfFrom}
              bg={props.bg}
              isLoading={isLoading}
            />
          </>
        )}
      </div>
    </>
  );
});

export default Summary;
